<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="8" height="14" viewBox="0 0 8 14" fill="none">
    <circle cx="1.26923" cy="1.26923" r="1.26923" fill="#417CE9" />
    <circle cx="1.26923" cy="12.3461" r="1.26923" fill="#417CE9" />
    <circle cx="1.26923" cy="6.80781" r="1.26923" fill="#417CE9" />
    <circle cx="5.80732" cy="1.26923" r="1.26923" fill="#417CE9" />
    <circle cx="5.80732" cy="12.3461" r="1.26923" fill="#417CE9" />
    <circle cx="5.80732" cy="6.80781" r="1.26923" fill="#417CE9" />
  </svg>
</template>
